import { useContext, useState } from 'react';
import { Box, Button, Heading, TextInput, Form, FormField, Select, } from 'grommet';
import { Close } from 'grommet-icons';
import { adminServices, competetiveService } from '../../services';
import { NotificationContext } from './NotificationContext';

export const AddResourceContent = ({ session, onCloseHandler, competitorOptions }) => {
    const [optionsForCompetitors, setOptionsForCompetitors] = useState([]);
    const [keyValuesForCompetitors, setKeValuesForCompetitors] = useState([]);
    const [selectedCompetitorId, setSelectedCompetitorId] = useState(null);
    const [selectedCompetitorProductId, setSelectedCompetitorProductId] = useState(null);
    const [optionsForCompetitorProducts, setOptionsForCompetitorProducts] = useState([])
    const [keyValuesForCompetitorProducts, setKeValuesForCompetitorProducts] = useState([]);
    const [optionsForResourceType, setOptionsForResourceTypes] = useState([])
    const [keyValuesForResourceTypes, setKeyValuesForResourcetypes] = useState([])
    const [selectedResourceType, setSelectedResourceType] = useState(null)
    const [formValues, setFormValue] = useState({
        'resource_title': '',
        'link': '',
        'is_enabled': true,
        'order': 0
    })
    const onChange = values => {
        setFormValue(values);
    }
    const { showNotification } = useContext(NotificationContext)
    useState(() => {
        competetiveService.getResourceTypes(session.user.access).then((data) => {
            let optionResourceTypes = []
            let keyResourceTypes = []
            if (data) {
                data.forEach(element => {
                    optionResourceTypes.push(element["resource_type"])
                    keyResourceTypes.push(element['id'])
                })
                setOptionsForResourceTypes(optionResourceTypes)
                setKeyValuesForResourcetypes(keyResourceTypes)
            }
        })

    }, [])
    useState(() => {
        let optionsCompetitors = []
        let keyCompetitors = []
        competitorOptions.forEach(element => {
            optionsCompetitors.push(element["competitor_name"])
            keyCompetitors.push(element['id'])
        })
        setOptionsForCompetitors(optionsCompetitors)
        setKeValuesForCompetitors(keyCompetitors)
    }, [])
    const onResourceSubmit = ({ value, touched }) => {
        console.log({ value })
        const formData = new FormData()
        formData.append('resource_title', value.resource_title)
        formData.append('link', value.link)
        formData.append('is_enabled', true)
        formData.append('order', 0)
        formData.append('resource_content_type', selectedResourceType)
        formData.append('competitor', selectedCompetitorId)
        formData.append('competitors_products', selectedCompetitorProductId)
        try {
            adminServices.addResource(formData, session.user.access)
            showNotification("Resource Successfully added", "normal")
            onCloseHandler()
        }
        catch (e) {
            let errMsg = e.toString()
            showNotification(errMsg, "critical")
            onCloseHandler()
        }
    }
    return <>
        <Box pad={"medium"} gap="small" overflow={"auto"} width={"medium"}
        >
            <Box direction="row" justify="between">
                <Heading level={2}>Add Competitive Document</Heading>
                <Button icon={<Close />} onClick={onCloseHandler} alignSelf="start" pad={"small"} justify="end" />
            </Box>
            <Box>
                <Form
                    validate='blur'
                    value={formValues}
                    messages={{ required: 'This is a required field' }}
                    onChange={nextValue => onChange(nextValue)}
                    onSubmit={({ value, touched }) => onResourceSubmit({ value, touched })}
                    method='post'>
                    <FormField label="Document Title" htmlFor='resource_title' name='resource_title'>
                        <TextInput id='resource_title' name='resource_title' />
                    </FormField>
                    <FormField label="Competitor">
                        <Select name="competitor_select" placeholder="Select Competitor" options={optionsForCompetitors} onChange={(option) => {
                            if (option) {
                                var temp = optionsForCompetitors.indexOf(option.option)
                                setSelectedCompetitorId(keyValuesForCompetitors[temp])
                                competetiveService.getCompetitorProducts(keyValuesForCompetitors[temp], session.user.access,).then((response) => {
                                    if (response) {
                                        let optionCompetitorProducts = []
                                        let kepCompetitorProducts = []
                                        response.forEach(element => {
                                            optionCompetitorProducts.push(element["competitor_product_name"])
                                            kepCompetitorProducts.push(element['id'])
                                        })
                                        setOptionsForCompetitorProducts(optionCompetitorProducts)
                                        setKeValuesForCompetitorProducts(kepCompetitorProducts)
                                    }
                                })
                            }
                        }} />
                    </FormField>
                    <FormField label="Competitor Products">
                        <Select name="competitor_product_select" placeholder="Select Competitor Product" options={optionsForCompetitorProducts} onChange={(option) => {
                            if (option) {
                                var temp = optionsForCompetitorProducts.indexOf(option.option)
                                setSelectedCompetitorProductId(keyValuesForCompetitorProducts[temp])
                            }
                        }} />
                    </FormField>
                    <FormField label="Resource Type">
                        <Select name="resourcestypes" placeholder="Select Resources Type" options={optionsForResourceType} onChange={(option) => {
                            if (option) {
                                var temp = optionsForResourceType.indexOf(option.option)
                                setSelectedResourceType(keyValuesForResourceTypes[temp])
                            }
                        }} />
                    </FormField>
                    <FormField label="Add Link" htmlFor='link' name='link'>
                        <TextInput name='link' id="link" />
                    </FormField>
                    <Box
                        // align={!['xsmall', 'small'].includes(size) ? 'end' : undefined}
                        justify="between"
                        margin={{ top: 'medium', bottom: 'small' }}
                        direction="row"
                    >
                        <Button label="Close" onClick={onCloseHandler} />
                        <Button label="Add Resource" primary type="submit" />
                    </Box>
                </Form>
            </Box>
        </Box>
    </>
}